import { ENV } from "@vrf/fr-vrf-core";
import { InDefCommonFlagType } from "../../util/general-code/enums/general-codes";

export const TEMPLATE_FILE_URL = {
  PIC_ADDRESS: "spreadsheet-template/component-list-page-pic-address.xlsx",
  COMPONENT_LIST:
    "spreadsheet-template/component-list-page-component-list.xlsx",
};

export const REQUEST_CD_TYPES = {
  IN_DEF_COMMON_FLAG_TYPE: "in_def_common_flag_type",
  CPNT_OWN_TYPE: "cpnt_own_type",
  CPNT_ALCTN_TYPE: "cpnt_alctn_type",
  CLOD_SRVC_RGN: "clod_srvc_rgn",
  CLOD_SRVC: "clod_srvc",
};

export const requestCdTypes = Object.values(REQUEST_CD_TYPES);

export const isChecked = (value: string) => value === InDefCommonFlagType.YES;
